import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const InsuranceRevenueLeasing = () => {
    
    const sections = [
        { label: "Status", value: "Status", items: [] },
        { label: "Insurance Type", value: "insuranceType", items: [] },
        { label: "Policy Status", value: "policyStatus", items: [] },
    ];

    return (
        <MasterData pageTitle="Insurance" sections={sections} />
    );
};

export default InsuranceRevenueLeasing;